import { getTokenFromCookies, setCookie, url } from "../utils/configData";

const renameID = (array) =>
  array.map((wallet) => {
    // Перейменування ключа '_id' на 'key'
    const updatedWallet = { ...wallet, key: wallet._id }; // Створення нового ключа 'key'
    delete updatedWallet._id; // Видалення старого ключа '_id'
    return updatedWallet;
  });



const fetchUserData = async () => {
  const end = "/users/me";
  const token = getTokenFromCookies();
  // Додаємо заголовок з токеном аутентифікації. Замініть YOUR_AUTH_TOKEN на ваш дійсний токен.
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });

    // Перевірка на успішність відповіді
    if (response.ok) {
      const userData = await response.json();
      // Встановлюємо isAuth у true, оскільки авторизація пройшла успішно
      return { ...userData, isAuth: true };
    } if (response.status === 433) {
      const userData = await response.json();
      return { ...userData };
    } else if (response.status === 412) {
      const userData = await response.json();
      return { ...userData, isAuth: false, NotCompleted: true };

    } else {
      return { isAuth: false };
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
    return { isAuth: false };
  }
};

const fetchCryptoWallets = (data) => {
  // Simulated fetch function
  console.log(data, "dataC");
  return Promise.resolve({
    cryptoWallets: renameID(data),
    isCryptoWallets: true,
  });
};

const fetchBankWallets = (data) => {
  // Simulated fetch function
  console.log(data, "data");
  return Promise.resolve({
    bankWallets: renameID(data),
    isBankWallets: true,
  });
};

const fetchUserWallets = async (id) => {
  const end = `/users/${id}/wallets`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const walletsData = await response.json();
      console.log(walletsData, "walletsData");
      return walletsData;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};


const fetchSocket = async (id) => {
  const end = `/chat/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {

     
      const data = await response.json();
      
      // setCookie("ws", data.wstoken, null);

      return data.wstoken;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchChatData = async (id) => {
  const end = `/transactions/chat/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });

    if (response.ok) {
      const chatData = await response.json();
      return chatData;
    } else if (response.status === 403) {
      return "user_not_permited";
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};


const fetchLimitValue = async (id) => {
  const end = `/limits/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });

    if (response.ok) {
      const limitData = await response.json();
      return limitData;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
}

const fetchUpdate = async (level) => {
  const end = `/verification/level/${level}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return { token: data.token, user_id: data.user_id };
    } else {
      return null;
    }
  }
  catch (error) {
    console.error("Failed to fetch user data:", error);
  }
}

export {
  fetchUserData,
  fetchCryptoWallets,
  fetchBankWallets,
  fetchUserWallets,
  fetchSocket,
  fetchLimitValue,
  fetchChatData,
  fetchUpdate,
};
